const constants = {
  POPUP_LABELS: {
    ARRIVAL_TIME: "ARRIVAL TIME",
    DEPARTURE_TIME: "DEPARTURE TIME",
    EST_ARRIVAL_TIME: "Est ARRIVAL TIME",
    EST_DEPARTURE_TIME: "Est DEPARTURE TIME",
    STOP_TIME: "STOP TIME",
    EST_STOP_TIME: "Est STOP TIME",
    SERVICE_WINDOW: "SERVICE WINDOW",
    STATUS : "STATUS",
    LATE_ARRIVAL : "LATE ARRIVAL",
    BILLS : "BILLS",
    FUEL_BREAK : "FUEL BREAK",
    LUNCH_BREAK : "LUNCH BREAK",
    REST_BREAK: "REST BREAK",
    PICKUP_NUMBER: "PICKUP#",
    PRO_NUMBER: "PRO#",
  },
};

export default constants;
